import { render, staticRenderFns } from "./Wbuy.vue?vue&type=template&id=39fad3c2"
import script from "./Wbuy.vue?vue&type=script&lang=js"
export * from "./Wbuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports